import React from 'react';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ContrastTable } from './components/ContrastTable';
import { TruthSection } from './components/TruthSection';
import { ProductPresentation } from './components/ProductPresentation';
import { ChaptersSection } from './components/ChaptersSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-cream text-neutral-800 font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <StickyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <ContrastTable data-id="element-5" />
        <TruthSection data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <ChaptersSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <ForWhoSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <UrgencySection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <ClosingSection data-id="element-16" />
      </main>
      <SocialProofPopup data-id="element-17" />
    </div>;
}